import { createContext, useContext } from "react";
import { typesetDicts } from "@b00k/domain";
import type { Lang } from "@b00k/domain";
import { pl } from "./pl.js";
import { en } from "./en.js";
import { de } from "./de.js";
import { fr } from "./fr.js";
import { it } from "./it.js";
import { es } from "./es.js";
import { zh } from "./zh.js";
import { ja } from "./ja.js";
import { ko } from "./ko.js";
import type { Dict } from "./pl.js";

export type { Dict };

// `Record<Lang, Dict>` jest tu kontraktem, nie ozdobą: dopisanie języka do
// `LANGS` bez słownika przestaje się kompilować, a brakujący klucz w słowniku
// wywala się na typie `Dict`. Kompletność tłumaczeń sprawdza więc typecheck,
// a nie czyjaś uwaga przy przeglądzie.
// Twarda spacja powstaje tu (raz), słowniki zostają ze zwykłymi spacjami.
export const DICTS: Record<Lang, Dict> = typesetDicts<Dict>({ pl, en, de, fr, it, es, zh, ja, ko });
export const I18nContext = createContext<Dict>(DICTS.pl);
export const useT = (): Dict => useContext(I18nContext);
